module.exports = __webpack_public_path__ + "img/toast-x-icon.9c5ec129.svg";